// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.api-key-box {
  /* max-width: 500px; */
  margin: 20px auto;
  padding: 16px;
  border: 1px solid #ddd;
  border-radius: 12px;
  background: #f9f9f9;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  font-family: sans-serif;
}

.api-key-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #333;
}

.api-key-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.api-key-input {
  flex: 1 1;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
  letter-spacing: 2px;
}

.api-key-toggle,
.api-key-copy {
  padding: 8px 12px;
  font-size: 13px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.2s;
}

.api-key-toggle {
  background: #007bff;
  color: #fff;
}

.api-key-toggle:hover {
  background: #0056b3;
}

.api-key-copy {
  background: #28a745;
  color: #fff;
}

.api-key-copy:hover {
  background: #1e7e34;
}

.api-key-note-box {
  background: #fefefe;
  border-left: 5px solid #007bff;
  padding: 16px 20px;
  margin-top: 15px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.api-key-note-box h4 {
  margin: 0 0 10px 0;
  font-size: 16px;
  color: #007bff;
}

.api-key-note-box ul {
  padding-left: 18px;
  margin: 0 0 10px 0;
}

.api-key-note-box li {
  margin-bottom: 6px;
}

.api-key-note-box .code-block {
  background: #2d2f3a;
  color: #00ffae;
  font-family: "Fira Code", monospace;
  font-size: 13px;
  padding: 8px 12px;
  border-radius: 6px;
  margin: 6px 0 10px 0;
  border: 1px solid #444;
  white-space: pre-wrap;
  width: -moz-fit-content;
  width: fit-content;
}

.api-doc-download {
    margin-top: 20px;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
}

.api-doc-link {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #004aad;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.2s ease;
}

.api-doc-link:hover {
    color: #003380;
}

.doc-icon {
    font-size: 20px;
}

`, "",{"version":3,"sources":["webpack://./src/pages/apikey/api-key.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".api-key-box {\n  /* max-width: 500px; */\n  margin: 20px auto;\n  padding: 16px;\n  border: 1px solid #ddd;\n  border-radius: 12px;\n  background: #f9f9f9;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.08);\n  font-family: sans-serif;\n}\n\n.api-key-label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #333;\n}\n\n.api-key-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.api-key-input {\n  flex: 1;\n  padding: 10px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  background: #fff;\n  letter-spacing: 2px;\n}\n\n.api-key-toggle,\n.api-key-copy {\n  padding: 8px 12px;\n  font-size: 13px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.api-key-toggle {\n  background: #007bff;\n  color: #fff;\n}\n\n.api-key-toggle:hover {\n  background: #0056b3;\n}\n\n.api-key-copy {\n  background: #28a745;\n  color: #fff;\n}\n\n.api-key-copy:hover {\n  background: #1e7e34;\n}\n\n.api-key-note-box {\n  background: #fefefe;\n  border-left: 5px solid #007bff;\n  padding: 16px 20px;\n  margin-top: 15px;\n  border-radius: 8px;\n  font-size: 14px;\n  line-height: 1.6;\n  color: #333;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n}\n\n.api-key-note-box h4 {\n  margin: 0 0 10px 0;\n  font-size: 16px;\n  color: #007bff;\n}\n\n.api-key-note-box ul {\n  padding-left: 18px;\n  margin: 0 0 10px 0;\n}\n\n.api-key-note-box li {\n  margin-bottom: 6px;\n}\n\n.api-key-note-box .code-block {\n  background: #2d2f3a;\n  color: #00ffae;\n  font-family: \"Fira Code\", monospace;\n  font-size: 13px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  margin: 6px 0 10px 0;\n  border: 1px solid #444;\n  white-space: pre-wrap;\n  width: fit-content;\n}\n\n.api-doc-download {\n    margin-top: 20px;\n    padding: 15px;\n    background: #f8f9fa;\n    border-radius: 8px;\n    border: 1px solid #e9ecef;\n}\n\n.api-doc-link {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: #004aad;\n    text-decoration: none;\n    font-weight: 500;\n    transition: color 0.2s ease;\n}\n\n.api-doc-link:hover {\n    color: #003380;\n}\n\n.doc-icon {\n    font-size: 20px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
